import * as SX from './sx';
import * as Styled from './styles';

import { Paper, Typography } from '@mui/material';
import { classnames, fDate, fHumanReadableNumber } from '@aibees/shared/utils';

import type { AccountPopoverCreditPlanDetailProps as Props } from './types';
import { memo } from 'react';
import { useAccountPopoverCreditPlanDetail } from './use-account-popover-credit-plan-detail';

export const AccountPopoverCreditPlanDetail = memo(
  ({ className, toRoute, variant = 'popover' }: Props) => {
    const { showRolloverHint, rollOver, renewalDate } =
      useAccountPopoverCreditPlanDetail();

    const formattedDate = fDate(renewalDate);
    const isEnrichment = variant === 'enrichment';

    return (
      <Styled.Wrapper
        className={classnames('AccountPopoverCreditPlanDetail', className)}
        sx={SX.root}
      >
        <Paper elevation={0} sx={SX.card(isEnrichment)}>
          <Typography variant="body4" color="grey.700">
            {showRolloverHint ? (
              <>
                Use your{' '}
                <Typography
                  component="span"
                  variant="body4"
                  fontWeight={700}
                  color="grey.800"
                >
                  {fHumanReadableNumber(rollOver)}
                </Typography>{' '}
                rollover credits before {isEnrichment ? ' ' : <br />}
                <Typography
                  component="span"
                  variant="body4"
                  fontWeight={700}
                  color="grey.800"
                >
                  {formattedDate}
                </Typography>
              </>
            ) : (
              <>
                Renews on{' '}
                <Typography
                  component="span"
                  variant="body4"
                  fontWeight={700}
                  color="grey.800"
                >
                  {formattedDate}
                </Typography>
              </>
            )}
          </Typography>
        </Paper>
      </Styled.Wrapper>
    );
  }
);

AccountPopoverCreditPlanDetail.displayName = 'AccountPopoverCreditPlanDetail';
